/* ============================================================
   Boost Blenz — Glossary category filter (functional, not cosmetic)
   Default state renders ALL cards visible from server markup, so if
   this script never runs (e.g. an old browser) nothing is hidden.
   Clicking a category pill fades non-matching cards out, then drops
   them from layout once the fade finishes; "All" restores everything.
   ============================================================ */
(function () {
  function initGlossary(root) {
    var sec = root.querySelector('[data-gl-filter]');
    if (!sec || sec.dataset.glReady === '1') return;
    sec.dataset.glReady = '1';

    var pills = sec.querySelectorAll('.gl-filter');
    var cards = sec.querySelectorAll('.gl-card');
    var DUR = 280; // keep in sync with --bb-dur in bb-glossary.css

    function apply(cat) {
      cards.forEach(function (card) {
        var cats = (card.getAttribute('data-cats') || '').split(' ');
        var match = cat === 'all' || cats.indexOf(cat) !== -1;
        if (match) {
          // bring back into layout, then fade in on the next frame
          card.hidden = false;
          requestAnimationFrame(function () { card.classList.remove('is-out'); });
        } else {
          card.classList.add('is-out');
          window.setTimeout(function () {
            if (card.classList.contains('is-out')) card.hidden = true;
          }, DUR);
        }
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        apply(pill.getAttribute('data-cat') || 'all');
      });
    });
  }

  function boot() { document.querySelectorAll('[data-gl-root]').forEach(initGlossary); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    initGlossary(e.target);
  });
})();
